import type { PortalInvoiceDetail, PortalInvoiceSummary } from "./database.types"

export function isSafeExternalUrl(value: string | null | undefined): value is string {
  if (!value) return false
  try {
    return new URL(value).protocol === "https:"
  } catch {
    return false
  }
}

export function getPortalInvoiceDisplayState(
  invoice: Pick<PortalInvoiceSummary, "amount_paid" | "document_kind" | "status" | "total">
) {
  const isLegacyCredit = invoice.document_kind === "legacy_credit"
  const amountPaid = Number(invoice.amount_paid || 0)
  const total = Number(invoice.total || 0)
  const isPartiallyPaid =
    !isLegacyCredit && invoice.status === "sent" && amountPaid > 0 && amountPaid < total

  return {
    isLegacyCredit,
    statusLabel: isLegacyCredit
      ? "Legacy credit"
      : isPartiallyPaid
        ? "Partially paid"
        : invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1),
    amountLabel: isLegacyCredit ? "Credit amount" : "Amount due",
    totalLabel: isLegacyCredit ? "Credit total" : "Invoice total",
  }
}

export function getPortalInvoicePaymentState(invoice: PortalInvoiceDetail) {
  const { isLegacyCredit } = getPortalInvoiceDisplayState(invoice)
  const amountDue =
    isLegacyCredit || invoice.status === "paid" || invoice.status === "void"
      ? 0
      : Math.max(Number(invoice.total || 0) - Number(invoice.amount_paid || 0), 0)
  const rawPaymentUrl = invoice.bank_details_snapshot?.payment_url
  const paymentUrl = !isLegacyCredit && isSafeExternalUrl(rawPaymentUrl) ? rawPaymentUrl : null
  const isDelivered = !isLegacyCredit && invoice.status === "sent"

  return {
    amountDue,
    paymentUrl,
    paymentLabel: isLegacyCredit
      ? "No payment due"
      : invoice.bank_details_snapshot?.payment_label || "Pay now",
    canPay: isDelivered && amountDue > 0 && paymentUrl !== null,
  }
}
